<template>
  <notificationGroup>
    <div class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
      <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
        <notification v-slot="{notifications, close: closeNotification}">
          <div
            class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
            v-for="(notification, index) in notifications"
            :key="index"
          >
            <transition
              enter-active-class="transition duration-300 ease-out transform"
              enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
              leave-active-class="transition duration-100 ease-in"
              leave-from-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div class="p-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <CheckCircleIcon
                      class="h-6 w-6 text-green-400"
                      aria-hidden="true"
                      v-if="notification.type === 'success'"
                    />
                    <ExclamationCircleIcon
                      class="h-6 w-6 text-red-400"
                      aria-hidden="true"
                      v-if="notification.type === 'error'"
                    />
                    <ExclamationCircleIcon
                      class="h-6 w-6 text-yellow-400"
                      aria-hidden="true"
                      v-if="notification.type === 'warning'"
                    />
                    <ExclamationCircleIcon
                      class="text-info-400 h-6 w-6"
                      aria-hidden="true"
                      v-if="notification.type === 'info'"
                    />
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="text-sm font-medium text-gray-900">{{ notification.title }}</p>
                    <p class="mt-1 text-sm text-gray-500">{{ notification.description }}</p>
                    <template v-if="notification.action">
                      <div class="mt-2">
                        <Link
                          :href="notification.action.url"
                          class="text-sm text-indigo-600 hover:text-indigo-800"
                        >
                          {{ notification.action.text }}
                        </Link>
                      </div>
                    </template>
                  </div>
                  <div class="ml-4 flex flex-shrink-0">
                    <button
                      @click="closeNotification(index)"
                      class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span class="sr-only">Close</span>
                      <XIcon
                        class="h-5 w-5"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </notification>
      </div>
    </div>
  </notificationGroup>
</template>

<script>
import {CheckCircleIcon, ExclamationCircleIcon} from '@heroicons/vue/outline';
import {XIcon} from '@heroicons/vue/solid';
export default {
  components: {
    XIcon,
    CheckCircleIcon,
    ExclamationCircleIcon,
  },
  methods: {
    closeNotification(index) {
      return index;
    },
  },
};
</script>
